module.exports = __webpack_public_path__ + "static/img/abc_s.069a902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/abc_s.jpg
// module id = YJ9z
// module chunks = 23